import { useBreakpointValue } from '@genial/utils';
import React, { useEffect } from 'react';

import { useRecoilQuery } from '../../../../../hooks/useRecoilQuery';
import { tradingListItemDetailSingleState } from '../../../../../store/trading/selector';
import { TradingConsolidateItem } from '../../../../../store/trading/types';

import { ContentDesktop } from './Desktop';
import { ContentMobile } from './Mobile';
import { ContentTablet } from './Tablet';

export interface PlatformCardProps {
  tradingListLoading?: boolean;
  platformName: string;
  balance: string;
  allocatedLimit: string;
  acceptableLoss: string;
  resultDay: string;
  tradings: TradingConsolidateItem[];
}

export interface PlatformBaseCardProps {
  id: number;
  idConta: number;
  sinacor: number;
  idContaSuperPNP: number;
  tradings: TradingConsolidateItem[];
  tradingListLoading?: boolean;
}

export const PlatformCard: React.FC<PlatformBaseCardProps> = ({
  id,
  idConta,
  idContaSuperPNP,
  sinacor,
  tradingListLoading,
  tradings,
}) => {
  const { loading, data, refresher } = useRecoilQuery(
    tradingListItemDetailSingleState({ id, idConta, idContaSuperPNP, sinacor }),
    {
      cachePolicy: 'no-cache',
    }
  );

  const { acceptableLoss, allocatedLimit, balance, platformName, resultDay } = data || {
    acceptableLoss: '--',
    allocatedLimit: '--',
    balance: '--',
    id,
    platformName: '--',
    resultDay: '--',
  };

  useEffect(() => {
    const interval = setInterval(() => {
      refresher();
    }, 3000);

    return () => clearInterval(interval);
  }, [refresher]);

  const content = useBreakpointValue({
    base: (
      <ContentMobile
        tradingListLoading={tradingListLoading || loading}
        platformName={platformName}
        balance={balance}
        allocatedLimit={allocatedLimit}
        acceptableLoss={acceptableLoss}
        resultDay={resultDay}
        tradings={tradings}
      />
    ),
    sm: (
      <ContentTablet
        tradingListLoading={tradingListLoading || loading}
        platformName={platformName}
        balance={balance}
        allocatedLimit={allocatedLimit}
        acceptableLoss={acceptableLoss}
        resultDay={resultDay}
        tradings={tradings}
      />
    ),
    md: (
      <ContentDesktop
        tradingListLoading={tradingListLoading || loading}
        platformName={platformName}
        balance={balance}
        allocatedLimit={allocatedLimit}
        acceptableLoss={acceptableLoss}
        resultDay={resultDay}
        tradings={tradings}
      />
    ),
  });

  return content;
};

PlatformCard.displayName = 'PlatformCard';
